import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import EditorRow from '../EditorRow';

function DescriptionField(props) {
  const { id } = props;
  return (
    <EditorRow width={500}>
      <label htmlFor={id}>Description (optional)</label>
      <TextField
        id={id}
        rows={1}
        name="description"
        value={props.value}
        multiline={true}
        fullWidth={true}
        rowsMax={4}
        onChange={e => props.onChange(e)}
      />
    </EditorRow>
  );
}

DescriptionField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

DescriptionField.defaultProps = {
  value: '',
};

export default DescriptionField;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/DescriptionField/index.jsx